import { faShoppingBag } from '@fortawesome/pro-solid-svg-icons';
import HeaderIconButton from 'components/HeaderIconButton';
import Badge from 'components/ui/Badge';
import useAppSelector from 'hooks/useAppSelector';
import useNavIconColor from 'hooks/useNavIconColor';
import styled from 'styled-components/macro';

const CartButton = ({ className }: { className: string }) => {
    const { quantity } = useAppSelector(({ cart }) => cart.cart);
    const { loading } = useAppSelector(({ cart }) => cart);
    const iconColor = useNavIconColor();

    return (
        <ButtonWrapper>
            <Icon
                small
                icon={faShoppingBag}
                iconColor={iconColor}
                className={` ${loading ? 'loading' : ''}`}
                aria-label="shoppingBag"
            />
            {(quantity ?? 0) > 0 && <Badge>{quantity}</Badge>}
        </ButtonWrapper>
    );
};
export default CartButton;

const ButtonWrapper = styled.div`
    position: relative;
`;

const Icon = styled(HeaderIconButton)<{ isLoading?: boolean }>`
    &.loading {
        animation: pulse 1s infinite;
    }

    @keyframes pulse {
        0% {
            transform: scale(0.95);
        }
        50% {
            transform: scale(1);
        }
        100% {
            transform: scale(0.95);
        }
    }
`;
